export const REQUEST_STATUS = {
    SUCCESS: 'SUCCESS',
    PENDING: 'PENDING',
    ERROR: 'ERROR',
};

export default {
    REQUEST_STATUS,
};
